import { IReactionDisposer, makeAutoObservable, reaction } from 'mobx';
import { CookiebotStateType } from 'src/domains/common/hooks';
import { getCookie, SESSIONS_COUNT, setCookie } from './DownloadAppBannerCookie';

export class DownloadAppBannerState {
    private isConsent: boolean;
    private isClosed: boolean = false;
    private isDownloaded: boolean = false;
    private sessions: number = SESSIONS_COUNT;
    private reaction: IReactionDisposer | null = null;

    public constructor(
        private readonly cookiebot: CookiebotStateType,
        private readonly link: string
    ) {
        makeAutoObservable(this);

        this.isConsent = this.cookiebot.loaded && this.cookiebot.consent.preferences;

        if (this.isConsent) {
            this.syncCookie();
            const cookie = getCookie();

            if (cookie.closed && cookie.sessions > 0) {
                const sessions = cookie.sessions - 1;
                this.sessions = sessions;
                this.isClosed = true;
            } else {
                this.sessions = SESSIONS_COUNT;
                this.isClosed = false;
            }

            this.isDownloaded = cookie.downloaded;
        }
    }

    public get isHidden(): boolean {
        return !this.isConsent || this.isClosed || this.isDownloaded;
    }

    public handleClose = (): void => {
        this.isClosed = true;
    };

    public handleDownload = (): void => {
        this.isDownloaded = true;
        window.location.href = this.link;
    };

    public dispose = (): void => {
        if (this.reaction === null) return;

        this.reaction();
    };

    private syncCookie = (): void => {
        this.reaction = reaction(
            () => ({
                closed: this.isClosed,
                downloaded: this.isDownloaded,
                sessions: this.sessions,
            }),
            (values) => {
                setCookie(values);
            },
            { fireImmediately: true }
        );
    };
}
